// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__24iyY","h1":"styles_h1__1_l7T","h2":"styles_h2__ZZpSN","h3":"styles_h3__fA665","h4":"styles_h4__LxYmy","h5":"styles_h5__2qiOQ"};